import { render, staticRenderFns } from "./VehicleTypeChip.vue?vue&type=template&id=945e60e6&lang=pug&"
import script from "./VehicleTypeChip.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypeChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports